export const helper = {
    methods: {
        checkStoryBookMode() {
            return Boolean(window['__storybook__']);
        },
        isNumericString(input) {
            return !isNaN(+input) && isFinite(+input);
        },
        toWordCase(str) {
            return str.replace(
                /\w\S*/g,
                (txt) =>
                    txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
            );
        },
        resizeImage(imgString, width, height, quality = 60, color = null) {
            if (!imgString) return imgString;
            const baseUrl = imgString.startsWith('https')
                ? ''
                : this.$globalConstants.imageUrl + '/';

            // skip resize params for gif images
            if (imgString && imgString.toLowerCase().includes('.gif')) {
                return `${baseUrl}${imgString}`;
            }
            let imageUrl = `${baseUrl}${imgString}?d=${width}x${height}&q=${quality}`;
            if (color) {
                color = color.substring(1); // remove # from the color value.
                imageUrl = `${imageUrl}&color=${color}`;
            }
            return imageUrl;
        },
        updateImageUrls(article) {
            try {
                const parser = new DOMParser();
                const doc = parser.parseFromString(
                    article['content'],
                    'text/html'
                );
                const images = doc.querySelectorAll('img');
                images.forEach((img) => {
                    if (this.isMobile()) {
                        img.src = this.resizeImage(img.src, 360, 400);
                    }
                    img.setAttribute('loading', 'lazy');
                });
                article['content'] = doc.body.innerHTML;
            } catch (e) {
                console.log(e);
            }

            return article;
        },
        fullPath(route) {
            if (this.$globalConstants.host['is_default_language']) return route;
            if (this.$globalConstants.host['language_code'])
                return window['__language_path__'] + route;
            return route;
        },
        randomString(length) {
            let result = '';
            const characters =
                'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            const charactersLength = characters.length;
            let counter = 0;
            while (counter < length) {
                result += characters.charAt(
                    Math.floor(Math.random() * charactersLength)
                );
                counter += 1;
            }
            return result;
        },
        loadArticleEditorStyleSheet(data) {
            if (!data['is_content_creator_styling']) return;

            let tagId = 'article-builder-stylesheet';
            if (!document.getElementById(tagId)) {
                let file = document.createElement('link');
                file.rel = 'stylesheet';
                file.id = tagId;
                file.href = `${this.$globalConstants.imageUrl}/content-builder/article-builder.css`;
                document.head.appendChild(file);
            }

            tagId = 'article-builder-stylesheet-font';
            if (!document.getElementById(tagId)) {
                if (document.getElementById(tagId)) return;
                let file = document.createElement('link');
                file.rel = 'stylesheet';
                file.id = tagId;
                file.href = `https://fonts.bunny.net/css?family=open-sans:300,300i,400,400i,500,500i,600,600i,700,700i,800,800i`;
                document.head.appendChild(file);
            }
        },
        attachTrackingParams(link) {
            let params = `clickin_id=${window['__clId__']}&user_token=${window['__token__']}`;

            try {
                const pageUrl = location.origin + location.pathname;
                params = `${params}&referer_url=${pageUrl}`;
            } catch (e) {
                console.log(e);
            }

            if (link && link.includes('?')) {
                return `${link}&${params}`;
            }
            return `${link}?${params}`;
        },
    },
    computed: {
        isStoryBookMode() {
            return this.checkStoryBookMode();
        },
        showReportContent() {
            return window.__host__?.show_report_content ?? true;
        },
    },
};

export function partnerScore(score) {
    if (score.toString().length < 2) {
        score = score + '.0';
    }
    return score.toString();
}

export function slugify(text) {
    return text
        .toString()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9 ]/g, '')
        .replace(/\s+/g, '-');
}
